import { createFileRoute } from '@tanstack/react-router';
import { SupplierDetailPage } from '@/pages/member-portal/suppliers/SupplierDetailPage';

function MemberPortalSupplierDetailRoute() {
	return <SupplierDetailPage />;
}

export const Route = createFileRoute('/_authenticated/_app/member-portal/suppliers/$id')({
	component: MemberPortalSupplierDetailRoute,
});
